const state = {
  startDate: '',
  endDate: '',
  cardNo: ''
}

const getters = {}

const mutations = {
  SET_QUERY_PRAMS(state, { startDate, endDate, cardNo }) {
    state.startDate = startDate
    state.endDate = endDate
    state.cardNo = cardNo
  },
  RESET(state) {
    state.startDate = ''
    state.endDate = ''
    state.cardNo = ''
  }
}

const actions = {
  setQueryPrams({ commit }, { startDate, endDate, cardNo }) {
    commit('SET_QUERY_PRAMS', { startDate, endDate, cardNo })
  },
  reset({ commit }) {
    commit('RESET')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
